<script setup lang="ts">
import * as uiLocales from '@nuxt/ui/locale'
import { getErrorMessage } from '~/utils/errors'

const runtimeConfig = useRuntimeConfig()
if (runtimeConfig.public.SITE_ENV === 'master') {
  useSeoMeta({ robots: 'noindex, nofollow' })
}

useSeoMeta({
  ogImage: 'https://s3-eu-west-1.amazonaws.com/static.byhours.com/img/usuarios/hotel_meta.jpg',
  twitterCard: 'summary_large_image',
  twitterImage: 'https://s3-eu-west-1.amazonaws.com/static.byhours.com/img/usuarios/hotel_meta.jpg'
})

// Idioma
const { locale } = useI18n()

// Obtener el locale de Nuxt UI según el locale de i18n
const uiLocale = computed(() => {
  const localeMap: Record<string, (typeof uiLocales)['es']> = {
    'es': uiLocales.es,
    'en': uiLocales.en,
    'de': uiLocales.de,
    'it': uiLocales.it,
    'fr': uiLocales.fr
  }
  return localeMap[locale.value] || uiLocales.es
})

// Iniciar dia
const selectedDiaStore = useSelectedDayStore()
selectedDiaStore.init()

// Iniciar Monedas (estado global)
const currencies: Ref<Currency[]> = useState('currencies')
await callOnce(async () => {
  try {
    const response = await $fetch<{ data: Currency[] }>(`${useBaseUrl()}/currencies`, {
      headers: { 'Content-Type': 'application/json' },
      query: { locale: locale.value }
    })
    currencies.value = response?.data || []
  } catch (error: unknown) {
    console.error('Error fetching currencies:', getErrorMessage(error))
    try {
      const response = await $fetch<Currency[]>('/api-web/currencies', {
        headers: { 'Content-Type': 'application/json' }
      })
      currencies.value = response as Currency[] || []
    } catch (fallbackError: unknown) {
      console.error('Error fetching currencies:', getErrorMessage(fallbackError))
    }
  }
})

// Iniciar Destino
const route = useRoute()
const selectedDestStore = useDestinationStore()
onMounted(async () => {
  await callOnce(async () => {
    selectedDestStore.initDestination(route)
  })
})

// Head
useHead({
  meta: [
    {
      name: 'viewport',
      content: 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover'
    }
  ],
  htmlAttrs: {
    lang: locale.value
  },
  link: [
    {
      rel: 'icon',
      href: '/favicon.ico'
    },
    {
      rel: 'preload',
      href: '/fonts/NHaasGroteskText.woff2',
      as: 'font',
      type: 'font/woff2',
      crossorigin: ''
    },
    {
      rel: 'preload',
      href: '/fonts/NHaasGroteskDisplay-bold.woff2',
      as: 'font',
      type: 'font/woff2',
      crossorigin: ''
    }
  ]
})
</script>

<template>
  <UApp :locale="uiLocale">
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </UApp>
</template>